/* eslint-disable */
import React, { useRef } from 'react'
import * as THREE from 'three'

import 'react-three-fiber'

function HomePlate({ position = [0, 0, 3] }) {
    const mesh = useRef()

    const rectWidth = 17 / 12.0
    const halfRectWidth = 0.5 * rectWidth
    const rectLength = 17 / 12.0
    const halfRectLength = 0.5 * rectWidth

    const rectShape = new THREE.Shape()
    rectShape.moveTo(0, 0)
    rectShape.lineTo(halfRectWidth, halfRectLength)
    rectShape.lineTo(halfRectWidth, rectLength)
    rectShape.lineTo(-halfRectWidth, rectLength)
    rectShape.lineTo(-halfRectWidth, halfRectLength)
    rectShape.lineTo(0, 0)

    const geometry = new THREE.ExtrudeGeometry(rectShape, {
        depth: 0.1,
        steps: 1,
        bevelEnabled: false,
    })
    const material = new THREE.MeshBasicMaterial({ color: 0xc2c2c2 })

    return (
        <mesh
            ref={mesh}
            name="base_hp"
            position={[position[0], 0, 6]}
            geometry={geometry}
            material={material}
        />
    )
}

export default HomePlate
